import { Table } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import styles from "./index.module.css";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import { Modal, TextComponent } from "../../../components";
import imagePlaceholder from "../../../assets/images/imagePlaceholder.png";
import FloatingButton from "../../../components/floatingButton/FloatBtn";
import { CompanyMiddleware } from "../../../Store/Middlewares/CompanyMiddleware";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import AddCustomer from "./AddCustomer";
import EditCustomer from "./UpdateCustomer";

const Customers = () => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState(null);
  const [editModal, setEditModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);

  const Customers = useSelector((state) => state.CompanyReducer?.getCustomers);
  const CustomersPagination = useSelector(
    (state) => state.CompanyReducer?.getPagination,
  );
  const getData = (name) => {
    dispatch(CompanyMiddleware.getCustomers(name)).then((data) => {});
  };
  useEffect(() => {
    getData();
  }, []);

  const pagecalculation = () => {
    if (!CustomersPagination?.meta) {
      return 0;
    }
    return (
      (CustomersPagination?.meta?.current_page - 1) *
      CustomersPagination?.meta?.per_page
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent
            text={pagecalculation() + index + 1}
            className={styles.versionText}
          />
        </div>
      ),
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      render: (item, data) => (
        <div className={styles.module}>
          {/* <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          /> */}
          <TextComponent
            text={data?.first_name}
            className={styles.moduletext}
          />
        </div>
      ),
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      render: (item, data) => (
        <div className={styles.module}>
          {/* <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          /> */}
          <TextComponent text={data?.last_name} className={styles.moduletext} />
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => (
        <div>
          <TextComponent text={text} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (data) => (
        <div className={styles.module}>
          <TextComponent text={data} className={styles.moduletext} />
        </div>
      ),
    },
    {
      title: "Contact",
      dataIndex: "contact_no",
      key: "contact_no",
      render: (text) => (
        <div className={styles.carDiv}>
          <TextComponent text={text} className={styles.text} />
        </div>
      ),
    },
  ];

  const updateCustomer = {
    title: "Edit",
    dataIndex: "update",
    key: "update",
    render: (item, data) => (
      <div>
        <FaEdit
          size={20}
          style={{ cursor: "pointer", color: "red" }}
          onClick={() => {
            setEditModal(true);
            setDetails(data);
          }}
        />
      </div>
    ),
  };

  return (
    <div className={styles.tableDiv}>
      <Table
        //   title={}
        scroll={{ x: true }}
        bordered={false}
        pagination={{
          showSizeChanger: false,
          showQuickJumper: false,
          current: CustomersPagination?.meta?.current_page,
          pageSize: CustomersPagination?.meta?.per_page,
          total: CustomersPagination?.meta?.total,
          onChange: (page, pageSize) => {
            dispatch(
              CompanyMiddleware.getSingleAssets({
                url: `${CustomersPagination?.meta?.path}?page=${page}`,
              }),
            );
          },
          itemRender: (_, type, originalElement) => {
            if (type === "prev") {
              return (
                <span
                  style={{
                    color: CustomersPagination?.links?.prev
                      ? "inherit"
                      : "#ccc",
                    cursor: CustomersPagination?.links?.prev
                      ? "pointer"
                      : "not-allowed",
                  }}
                  onClick={() => {
                    dispatch(
                      CompanyMiddleware.getCustomers({
                        url: CustomersPagination?.links?.prev,
                      }),
                    );
                  }}
                >
                  <LeftOutlined /> Prev
                </span>
              );
            }
            if (type === "next") {
              return (
                <span
                  style={{
                    color: CustomersPagination?.links?.next
                      ? "inherit"
                      : "#ccc",
                    cursor: CustomersPagination?.links?.next
                      ? "pointer"
                      : "not-allowed",
                  }}
                  onClick={() => {
                    dispatch(
                      CompanyMiddleware.getCustomers({
                        url: CustomersPagination?.links?.next,
                      }),
                    );
                  }}
                >
                  Next <RightOutlined />
                </span>
              );
            }
            return originalElement;
          },
        }}
        columns={[...columns, updateCustomer]}
        dataSource={Customers}
      />

      {/* {width > 550 ? ( */}
      <>
        <FloatingButton
          Buttons={[
            {
              title: "Add Customer",
              onClick: () => setAddModal(true),
            },
          ]}
          button_message={"Add"}
        />
      </>
      {/* ) : (
      <div className={styles.addNewResponsiveBtn}>
        <FaCirclePlus size={60} style={{ marginRight: "5px" }} />
      </div>
    )} */}
      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        icon={
          <AiOutlineQuestionCircle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        twoButton
        okBtnTitle={"Yes, delete"}
        cancelBtnTitle={"No, go back"}
        title={"Are you sure"}
        text={"You want to delete this asset?"}
        width={400}
        // btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setDeleteModal(false);
        }}
        onClickOkButton={() => {
          dispatch(AssetsMiddleware.deleteAssets(details?.id)).then(() => {
            setDeleteModal(false);
            setSuccess(true);
          });
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Asset Deleted successfully"}
        width={"300px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <AddCustomer
        openModel={addModal}
        setopenModel={setAddModal}
        getData={getData}
      />
      <EditCustomer
        openModel={editModal}
        setopenModel={setEditModal}
        setDetails={setDetails}
        details={details}
        getData={getData}
      />
    </div>
  );
};

export default Customers;
